module.exports = __webpack_public_path__ + "static/P1011958-9f1ae664332c4cfe320f6c1b70c81fcb.jpg";